import script from "./FormulasGAQGodApe.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasGAQGodApe.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__